import styles from './MobileRecoveryComponent.module.css';
import { BentoCard } from './BentoCard';

export const MobileRecoveryComponent = ({
  className,
}: {
  className?: string;
}) => {
    return (
      <div className={className ? `${styles.root} ${className}` : styles.root}>
        <div className="head">
          <h2>Where you and yours feel most at Home</h2>
          <p>
            Understand how to make your space better. Your Room Score reflects
            the current state of your home. Access insights on air quality,
            light exposure, temperature, noise, and humidity.
          </p>
        </div>

        <div className="sleep-items-container u-hide-scrollbar">
          <div className="items">
            <BentoCard
              gridColumn="1 / span 6"
              gridRow="2 / 3"
              caption="ROOM SCORE"
              title={
                <>
                  Your environment,
                  <br />
                  decoded
                </>
              }
              alt="Your space, decoded"
              textColor="#ffffff"
              bgGradient="radial-gradient(108.68% 108.68% at 50% -8.68%, #09CC6E 0%, #000 81.42%)"
              textAlign="left"
              image="web_v2/home/bento-new/room-score-sm.png"
              parentType="flex"
            />

            <BentoCard
              gridColumn="7 / span 5"
              gridRow="2 / 3"
              caption="Environment contributors"
              title="A breakdown of your environment"
              alt="The anatomy of your environment"
              textColor="#000000"
              bgColor="#ffffff"
              textAlign="left"
              image="web_v2/home/bento-new/environment-sm.png"
              colReverse
              parentType="flex"
            />

            <BentoCard
              gridColumn="1 / span 4"
              gridRow="3 / 4"
              caption="NOISE DETECTION"
              title={
                <>
                  Understand your
                  <br />
                  environment&apos;s noise levels
                </>
              }
              alt="For a more quieter space"
              textColor="#ffffff"
              textAlign="left"
              bgImage="/web_v2/home/bento-new/noise-detection-sm.png"
              parentType="flex"
            />

            <BentoCard
              gridColumn="5 / span 7"
              gridRow="3 / 4"
              caption="AIR QUALITY"
              title="Understand your air quality"
              alt="Your space, decoded"
              textColor="#ffffff"
              bgImage="/web_v2/home/bento-new/air-quality-bg-sm.png"
              textAlign="left"
              image="web_v2/home/bento-new/air-quality-sm-v2.png"
              parentType="flex"
            />

            <BentoCard
              gridColumn="1 / span 5"
              gridRow="4 / 5"
              caption="ENVIRONMENTAL SCORE"
              title={<>Create a restful environment</>}
              alt="For a more quieter space"
              textColor="#ffffff"
              textAlign="left"
              bgImage="/web_v2/home/bento-new/env-score-sm-v3.png"
              parentType="flex"
            />

            <BentoCard
              gridColumn="6 / span 6"
              gridRow="4 / 5"
              caption="LIGHT EXPOSURE"
              title={
                <>
                  Align with your
                  <br />
                  circadian rhythm
                </>
              }
              alt="For a more quieter space"
              textColor="#000000"
              textAlign="left"
              bgImage="/web_v2/home/bento-new/light-exp-bg-sm.png"
              image="web_v2/home/bento-new/light-exp-sm.png"
              parentType="flex"
            />
          </div>
          {/* <div className="items">
            <div className="item recovery">
              <div className="content">
                <h4>ROOM SCORE</h4>
                <h3>Your space, decoded</h3>
              </div>
            </div>
            <div className="item temperature">
              <div className="content">
                <h4>Environment contributors</h4>
                <h3>
                  The anatomy of
                  <br />
                  your environment
                </h3>
                <div className="img-container">
                  <Image
                    src={'web_v2/ring-buy/recovery/svg/tempRes.svg'}
                    fill
                    alt="temperature-img"
                    className="temperature-img"
                  />
                </div>
              </div>
            </div>
            <div className="item hrv">
              <div className="content">
                <h4>
                  {t('ring.bentoRecoverySection.hrvCard.title')}
                </h4>
                <h3>
                  {t('ring.bentoRecoverySection.hrvCard.subtitleA')}
                  <br />{' '}
                  {t('ring.bentoRecoverySection.hrvCard.subtitleB')}
                </h3>
                <div className="img-container">
                  <Image
                    src={'web_v2/ring-buy/recovery/png/asset.png'}
                    fill
                    alt="contributor-img"
                    className="contributorImg"
                  />
                </div>
              </div>
            </div>
            <div className="item stress">
              <div className="content">
                <h4>
                  {t('ring.bentoRecoverySection.stressCard.title')}
                </h4>
                <h3>
                  {t('ring.bentoRecoverySection.stressCard.subtitleA')}{' '}
                  {t('ring.bentoRecoverySection.stressCard.subtitleB')}
                </h3>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
};
